import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";
import FileUploadHandler from "components/fileuploader/FileUploadHandler";

export type RevisionRequestModalProps = {
  isOpen: boolean;
  onClose: () => void;
  revisionText: string;
  onChangeRevisionText: (value: string) => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
};

export default function RevisionRequestModal({
  isOpen,
  onClose,
  revisionText,
  onChangeRevisionText,
  onSubmit,
  isSubmitting = false,
}: RevisionRequestModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay bg="rgba(0,0,0,0.4)" />
      <ModalContent borderRadius="18px" maxW="548px" p="32px">
        <ModalHeader
          p="0px"
          m="0px 0px 24px 0px"
          fontSize="24px"
          fontWeight="600"
          color="#0B0E10"
        >
          Submit a revision request
        </ModalHeader>
        <ModalCloseButton
          mt="10px"
          mr="10px"
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
          _focus={{ bg: "transparent" }}
        />
        <ModalBody p="0px">
          <FormControl mb="20px">
            <FormLabel
              fontSize="16px"
              fontWeight="600"
              color="#0B0E10"
              mb="8px"
            >
              What revisions do you need?
            </FormLabel>
            <Textarea
              placeholder="Explain the revisions needed in detail."
              value={revisionText}
              onChange={(e) => onChangeRevisionText(e.target.value)}
              minH="140px"
              borderRadius="12px"
              fontSize="14px"
              border="1px solid #D2DAE5"
              _placeholder={{ color: "#9CA3AF" }}
              _hover={{ border: "1px solid #D2DAE5" }}
              _focus={{ border: "1px solid #D2DAE5" }}
            />
          </FormControl>

          <FormControl mb="24px">
            <FormLabel
              fontSize="16px"
              fontWeight="600"
              color="#0B0E10"
              mb="8px"
            >
              Upload document (optional)
            </FormLabel>
            <FileUploadHandler />
          </FormControl>
        </ModalBody>
        <ModalFooter p="0px" gap="24px">
            <Button
              bgColor="#FFFFFF"
              color="#3A7BFF"
              h="48px"
              w="230px"
              border="1px solid #3A7BFF"
              _hover={{
                bgColor: "#3A7BFF",
                color: "#FFF",
              }}
              _active={{
                bgColor: "#FFFFFF",
                color: "#3A7BFF",
              }}
              onClick={onClose}
              borderRadius="25px"
            >
              Cancel
            </Button>
            <Button
              bgColor="#3A7BFF"
              color="white"
              h="48px"
              w="230px"
              border="1px solid #3A7BFF"
              _hover={{
                bgColor: "#FFFFFF",
                color: "#3A7BFF",
              }}
              _active={{
                bgColor: "#FFFFFF",
                color: "#3A7BFF",
              }}
              _loading={{ pointerEvents: "none" }}
              onClick={onSubmit}
              isLoading={isSubmitting}
              disabled={isSubmitting || !revisionText.trim()}
              borderRadius="25px"
            >
              Submit request
            </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
